module.exports = __webpack_public_path__ + "img/广告图三.2802c3d8.jpg";